import { ByLocales, Locales } from '@monoimin/sb-types';

type CustomNames = ByLocales<Locales, { [code: string]: string }>;

export const customRegionNamesDict: CustomNames = {
  en: {
    TR: 'Turkey',
    US: 'United States',
    europe: 'Europe',
    caribbean: 'Caribbean',
    LC: 'St Lucia',
    KN: 'St Kitts & Nevis',
    AE: 'UAE',
  },
  de: {
    TR: 'Türkei',
    US: 'Vereinigte Staaten',
    europe: 'Europa',
    caribbean: 'Karibik',
    LC: 'St Lucia',
    KN: 'St Kitts & Nevis',
    AE: 'VAE',
  },
  ru: {
    TR: 'Турция',
    US: 'США',
    europe: 'Европа',
    caribbean: 'Карибы',
    LC: 'Сент-Люсия',
    KN: 'Сент-Китс и Невис',
    AE: 'ОАЭ',
  },
  tr: {
    TR: 'Türkiye',
    US: 'Amerika Birleşik Devletleri',
    europe: 'Avrupa',
    caribbean: 'Karayipler',
    LC: 'St Lucia',
    KN: 'St Kitts & Nevis',
    AE: 'BAE',
  },
  es: {
    TR: 'Turquía',
    US: 'Estados Unidos',
    europe: 'Europa',
    caribbean: 'Caribe',
    LC: 'St Lucia',
    KN: 'St Kitts & Nevis',
    AE: 'EAU',
  },
};
